import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useEnglishLevel } from '../leveling/useEnglishLevel.js';

/**
 * Gate inverso de las pantallas de onboarding "de datos" (/welcome, /goal): si
 * el user YA está onboardeado y cae acá (bookmark, botón atrás, link viejo, o
 * un signup mal marcado como nuevo), lo devuelve a /home en vez de re-mostrarle
 * el onboarding. Es el espejo de `HomeOrA0`, que manda a los NO onboardeados
 * HACIA acá — lee el MISMO caché de `/state`, así las dos decisiones nunca se
 * contradicen (sin loop de redirects).
 *
 * Sólo rebota cuando SABE que está onboardeado (`state.onboarded`). Mientras
 * `/state` no cargó —o falló— renderiza el onboarding: el user legítimo (nuevo
 * o a mitad) pertenece acá, y así NO le metemos un loader al camino común (que
 * llega con el caché caliente desde `HomeOrA0`, o frío desde el signup OTP). Un
 * onboardeado que entra directo ve un instante la pantalla y rebota cuando
 * `/state` resuelve.
 *
 * NO se envuelve `/onboarding/level`: esa pantalla COMPLETA el onboarding
 * (markOnboarded) y navega sola al resultado, así que gatearla desde afuera
 * —con un caché que se revalida en cualquier momento— arriesgaría una carrera
 * con su navegación de cierre. Su rebote lo hace ella misma (`bounce`), con la
 * lectura única de `/state` del mount.
 */
interface RedirectIfOnboardedProps {
  children: ReactNode;
}

export function RedirectIfOnboarded({ children }: RedirectIfOnboardedProps) {
  const { state } = useEnglishLevel();
  if (state?.onboarded) return <Navigate to="/home" replace />;
  return <>{children}</>;
}
